<template>
  <v-flex
    xs12
  >
    <v-layout
      row
      wrap
    >
      <v-flex
        xs12
        md4
        offset-md1
      >
        <v-flex :class="disabled ? 'text--disabled' : ''">
          <h3 class="title font-weight-regular pt-3">
            {{ $t('VAT Rates') }}
          </h3>
          <span class="caption">
            {{ $t('Customize your VAT rates.') }}
          </span>
        </v-flex>
        <v-flex
        >
          <v-btn
            :disabled="disabled"
            class="mx-0"
            @click="addNewVat"
          >
            {{ $t('Add VAT rate') }}
          </v-btn>
        </v-flex>
      </v-flex>
      <v-flex
        xs12
        md6
      >
        <v-card
          flat
          class="pa-3"
        >
          <LoadingStateMicro
            v-if="!taxes"
            :loading="true"
          />
          <template v-else>
            <div v-if="taxes.length">
              <v-list
                v-for="(vat, index) in taxes"
                :key="vat.id"
                :disabled="disabled"
                two-line
                subheader
              >
                <v-list-tile
                  :disabled="disabled"
                  @click="editVat(vat)"
                >
                  <v-list-tile-content>
                    <v-list-tile-title>{{ vat.name }}</v-list-tile-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <span color="primary--text">{{ $t('Rate:') }} {{ vat.value }}%</span>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider
                  v-if="index < taxes.length-1"
                />
              </v-list>
            </div>
            <v-list-tile v-else>
              {{ $t('No VAT rates to display') }}
            </v-list-tile>
          </template>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <settings-vat-rate
        v-if="dialog"
        :vat="selectedVat"
        @saved="reloadTaxes"
        @closed="dialog = false"
      />
    </v-dialog>
  </v-flex>
</template>

<script>
import SettingsTaxRateWidget from '@/modules/Settings/components/Taxes/SettingsTaxRateWidget'
import SettingsVatRate from '@/modules/Settings/components/Taxes/SettingsVatRate'
import LoadingStateMicro from '@/components/LoadingStateMicro'

export default {
  name: 'VatRatesList',

  components: {
    LoadingStateMicro,
    SettingsVatRate,
    SettingsTaxRateWidget
  },

  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      taxes: [],
      selectedVat: {},
      dialog: false,
      taxRates: []
    }
  },

  async created () {
    await this.loadTaxes()
  },

  methods: {
    addNewVat () {
      this.selectedVat = {}
      this.dialog = true
    },

    editVat (vat) {
      this.selectedVat = vat
      this.dialog = true
    },

    reloadTaxes () {
      this.loadTaxes()
      this.selectedVat = {}
      this.dialog = false
    },

    async loadTaxes () {
      this.taxes = await this.$http.make('vat').limit(-1).get()
    }
  }
}
</script>
